module.exports = __webpack_public_path__ + "media/1fie-k-niswkan.72978a4c.mp3";